
const menuExportableProps = {
    offsetY: {
        type: Boolean,
        default: true,
    },
    transition: {
        type: String,
        default: "slide-y-transition"
    },
    closeOnContentClick: {
        type: Boolean,
        default: true
    },
    minHeight: [String, Number],
    maxHeight: [String, Number],
    minWidth: [String, Number],
    maxWidth: [String, Number],
    nudgeLeft: [String, Number],
};


export const dropdownMixin = {
    props: {
        ...menuExportableProps,
    },
    computed: {
        menuProps() {
            const allProps = this.$props;
            let props = {};
            for (const key in allProps) {
                if (Object.hasOwnProperty.call(menuExportableProps, key)) {
                    props[key] = allProps[key];
                }
            }
            return props;
        }
    }
};